module.exports = [{"key":"industry","name":"行业","data":[{"key":"1","name":"集团行业"},{"key":"2","name":"政府行业"},{"key":"3","name":"外企行业"},{"key":"4","name":"医疗行业"},{"key":"5","name":"食品行业"},{"key":"6","name":"地产行业"},{"key":"7","name":"鞋服行业"}]},{"key":"function","name":"职能","data":[{"key":"1","name":"财务管理"},{"key":"2","name":"人事管理"},{"key":"3","name":"行政管理"},{"key":"4","name":"采购管理"},{"key":"5","name":"合同管理"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/home/datas_category_workflow.json
// module id = 1372
// module chunks = 0